import actions from './actions';
import types from './types';

const analyticsModule = {
  state: () => ({
    // Dashboard
    overview: null,
    overviewLoading: false,
    errorTrend: null,
    errorTrendLoading: false,
    errorsByType: null,
    errorsByTypeLoading: false,
    errorsByBrowser: null,
    errorsByBrowserLoading: false,
    errorsByPage: null,
    errorsByPageLoading: false,
    apiPerformance: null,
    apiPerformanceLoading: false,

    // Sessions
    sessions: [],
    sessionsTotal: 0,
    sessionsLoading: false,
    sessionDetail: null,
    sessionDetailLoading: false,
    sessionEvents: null,
    sessionEventsLoading: false,

    // Heatmaps
    heatmapPages: [],
    heatmapPagesTotal: 0,
    heatmapPagesLoading: false,
    heatmapClicks: null,
    heatmapClicksLoading: false,

    // Frontend Errors
    frontendErrors: [],
    frontendErrorsTotal: 0,
    frontendErrorsLoading: false,
    frontendErrorDetail: null,
    frontendErrorDetailLoading: false,
    resolvingFrontendErrors: false,

    // Alerts
    alertRules: [],
    alertRulesLoading: false,
    alertHistory: [],
    alertHistoryTotal: 0,
    alertHistoryLoading: false,
    creatingAlertRule: false,
    updatingAlertRule: false,
    deletingAlertRule: false,

    error: null,
  }),
  mutations: {
    // Dashboard
    [types.GET_OVERVIEW_START]: (state) => {
      state.overviewLoading = true;
    },
    [types.GET_OVERVIEW_SUCCESS]: (state, data) => {
      state.overview = data;
      state.overviewLoading = false;
    },
    [types.GET_OVERVIEW_FAILURE]: (state) => {
      state.overviewLoading = false;
    },

    [types.GET_ERROR_TREND_START]: (state) => {
      state.errorTrendLoading = true;
    },
    [types.GET_ERROR_TREND_SUCCESS]: (state, data) => {
      state.errorTrend = data;
      state.errorTrendLoading = false;
    },
    [types.GET_ERROR_TREND_FAILURE]: (state) => {
      state.errorTrendLoading = false;
    },

    [types.GET_ERRORS_BY_TYPE_START]: (state) => {
      state.errorsByTypeLoading = true;
    },
    [types.GET_ERRORS_BY_TYPE_SUCCESS]: (state, data) => {
      state.errorsByType = data;
      state.errorsByTypeLoading = false;
    },
    [types.GET_ERRORS_BY_TYPE_FAILURE]: (state) => {
      state.errorsByTypeLoading = false;
    },

    [types.GET_ERRORS_BY_BROWSER_START]: (state) => {
      state.errorsByBrowserLoading = true;
    },
    [types.GET_ERRORS_BY_BROWSER_SUCCESS]: (state, data) => {
      state.errorsByBrowser = data;
      state.errorsByBrowserLoading = false;
    },
    [types.GET_ERRORS_BY_BROWSER_FAILURE]: (state) => {
      state.errorsByBrowserLoading = false;
    },

    [types.GET_ERRORS_BY_PAGE_START]: (state) => {
      state.errorsByPageLoading = true;
    },
    [types.GET_ERRORS_BY_PAGE_SUCCESS]: (state, data) => {
      state.errorsByPage = data;
      state.errorsByPageLoading = false;
    },
    [types.GET_ERRORS_BY_PAGE_FAILURE]: (state) => {
      state.errorsByPageLoading = false;
    },

    [types.GET_API_PERFORMANCE_START]: (state) => {
      state.apiPerformanceLoading = true;
    },
    [types.GET_API_PERFORMANCE_SUCCESS]: (state, data) => {
      state.apiPerformance = data;
      state.apiPerformanceLoading = false;
    },
    [types.GET_API_PERFORMANCE_FAILURE]: (state) => {
      state.apiPerformanceLoading = false;
    },

    // Sessions
    [types.GET_SESSIONS_START]: (state) => {
      state.sessionsLoading = true;
    },
    [types.GET_SESSIONS_SUCCESS]: (state, data) => {
      state.sessions = data.data || [];
      state.sessionsTotal = data.total || 0;
      state.sessionsLoading = false;
    },
    [types.GET_SESSIONS_FAILURE]: (state) => {
      state.sessionsLoading = false;
    },

    [types.GET_SESSION_DETAIL_START]: (state) => {
      state.sessionDetailLoading = true;
    },
    [types.GET_SESSION_DETAIL_SUCCESS]: (state, data) => {
      state.sessionDetail = data;
      state.sessionDetailLoading = false;
    },
    [types.GET_SESSION_DETAIL_FAILURE]: (state) => {
      state.sessionDetailLoading = false;
    },

    [types.GET_SESSION_EVENTS_START]: (state) => {
      state.sessionEventsLoading = true;
    },
    [types.GET_SESSION_EVENTS_SUCCESS]: (state, data) => {
      state.sessionEvents = data;
      state.sessionEventsLoading = false;
    },
    [types.GET_SESSION_EVENTS_FAILURE]: (state) => {
      state.sessionEventsLoading = false;
    },

    [types.CLEAR_SESSION_DETAIL]: (state) => {
      state.sessionDetail = null;
      state.sessionEvents = null;
    },

    // Heatmaps
    [types.GET_HEATMAP_PAGES_START]: (state) => {
      state.heatmapPagesLoading = true;
    },
    [types.GET_HEATMAP_PAGES_SUCCESS]: (state, data) => {
      state.heatmapPages = data.pages || [];
      state.heatmapPagesTotal = data.total || 0;
      state.heatmapPagesLoading = false;
    },
    [types.GET_HEATMAP_PAGES_FAILURE]: (state) => {
      state.heatmapPagesLoading = false;
    },

    [types.GET_HEATMAP_CLICKS_START]: (state) => {
      state.heatmapClicksLoading = true;
    },
    [types.GET_HEATMAP_CLICKS_SUCCESS]: (state, data) => {
      state.heatmapClicks = data;
      state.heatmapClicksLoading = false;
    },
    [types.GET_HEATMAP_CLICKS_FAILURE]: (state) => {
      state.heatmapClicksLoading = false;
    },

    // Frontend Errors
    [types.GET_FRONTEND_ERRORS_START]: (state) => {
      state.frontendErrorsLoading = true;
    },
    [types.GET_FRONTEND_ERRORS_SUCCESS]: (state, data) => {
      state.frontendErrors = data.data || [];
      state.frontendErrorsTotal = data.total || 0;
      state.frontendErrorsLoading = false;
    },
    [types.GET_FRONTEND_ERRORS_FAILURE]: (state) => {
      state.frontendErrorsLoading = false;
    },

    [types.GET_FRONTEND_ERROR_DETAIL_START]: (state) => {
      state.frontendErrorDetailLoading = true;
    },
    [types.GET_FRONTEND_ERROR_DETAIL_SUCCESS]: (state, data) => {
      state.frontendErrorDetail = data;
      state.frontendErrorDetailLoading = false;
    },
    [types.GET_FRONTEND_ERROR_DETAIL_FAILURE]: (state) => {
      state.frontendErrorDetailLoading = false;
    },

    [types.RESOLVE_FRONTEND_ERRORS_START]: (state) => {
      state.resolvingFrontendErrors = true;
    },
    [types.RESOLVE_FRONTEND_ERRORS_SUCCESS]: (state) => {
      state.resolvingFrontendErrors = false;
    },
    [types.RESOLVE_FRONTEND_ERRORS_FAILURE]: (state) => {
      state.resolvingFrontendErrors = false;
    },

    [types.CLEAR_FRONTEND_ERROR_DETAIL]: (state) => {
      state.frontendErrorDetail = null;
    },

    // Alerts
    [types.GET_ALERT_RULES_START]: (state) => {
      state.alertRulesLoading = true;
    },
    [types.GET_ALERT_RULES_SUCCESS]: (state, data) => {
      state.alertRules = data || [];
      state.alertRulesLoading = false;
    },
    [types.GET_ALERT_RULES_FAILURE]: (state) => {
      state.alertRulesLoading = false;
    },

    [types.GET_ALERT_HISTORY_START]: (state) => {
      state.alertHistoryLoading = true;
    },
    [types.GET_ALERT_HISTORY_SUCCESS]: (state, data) => {
      state.alertHistory = data.data || [];
      state.alertHistoryTotal = data.total || 0;
      state.alertHistoryLoading = false;
    },
    [types.GET_ALERT_HISTORY_FAILURE]: (state) => {
      state.alertHistoryLoading = false;
    },

    [types.CREATE_ALERT_RULE_START]: (state) => {
      state.creatingAlertRule = true;
    },
    [types.CREATE_ALERT_RULE_SUCCESS]: (state) => {
      state.creatingAlertRule = false;
    },
    [types.CREATE_ALERT_RULE_FAILURE]: (state) => {
      state.creatingAlertRule = false;
    },

    [types.UPDATE_ALERT_RULE_START]: (state) => {
      state.updatingAlertRule = true;
    },
    [types.UPDATE_ALERT_RULE_SUCCESS]: (state) => {
      state.updatingAlertRule = false;
    },
    [types.UPDATE_ALERT_RULE_FAILURE]: (state) => {
      state.updatingAlertRule = false;
    },

    [types.DELETE_ALERT_RULE_START]: (state) => {
      state.deletingAlertRule = true;
    },
    [types.DELETE_ALERT_RULE_SUCCESS]: (state) => {
      state.deletingAlertRule = false;
    },
    [types.DELETE_ALERT_RULE_FAILURE]: (state) => {
      state.deletingAlertRule = false;
    },
  },
  actions,
  namespaced: true,
};

export default analyticsModule;
